import axios from 'axios';

export const getEntityDetail = async (entityId) => axios.get(`/api/farm/entity/${entityId}/`);
export const getRanchDetail = async (ranchId) => axios.get(`/api/farm/ranch/${ranchId}/`);
export const getBlockDetail = async (blockId) => axios.get(`/api/farm/block/${blockId}/`);

export const getEntityList = async (filter = false) => {
    return axios.get('/api/farm/entity/', filter ? { params: { filter: 1 } } : '');
}
export const getRanchList = async (filter = false) => {
    return axios.get('/api/farm/ranch/', filter ? { params: { filter: 1 } } : '');
}
export const getBlockList = async (filter = false) => {
    return axios.get('/api/farm/block/', filter ? { params: { filter: 1 } } : '');
}

export const getAvailableRanchList = async () => axios.get('/api/farm/ranch/available/');

export const postRanchGeoJson = async ({ entityId, ranchGeojson }) => axios.post('/api/ranch/geojson/', {
  entityId,
  ranchGeojson,
});

export const getBlockAvailableWater = async (blockId) => axios.get(`/api/block/${blockId}/soil/currentwater/`);

export const updateBlockAutoSchedule = async ({ autoSchedule, blockId }) => (
    axios.patch(`/api/farm/block/${blockId}/`, {
        auto_schedule: autoSchedule,
    })
);

export const getChillHours = (ranchId) =>  axios.get(`/api/ranches/${ranchId}/chillhours/`);

export const getChillPortions = (ranchId) =>  axios.get(`/api/ranches/${ranchId}/chillportions/`);

export const getRanchPrecip = (ranchId) => axios.get(`/api/ranches/${ranchId}/precip`);
export const getRanchRainfallDaily = (ranchId) => axios.get(`/api/ranches/${ranchId}/rainfall/daily/`);

export const getCumulativePrecipitation = ({ ranchId, start, end }) =>  (
    axios.get(`/api/ranches/${ranchId}/precip/cumulative/?start=${start}&end=${end}`)
);

export const getGDD = ({ ranchId, lower, upper }) =>  (
    axios.get(`/api/ranches/${ranchId}/gdd/?lower=${lower}&upper=${upper}`)
);
